import React from "react";
import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReviewList from "./ReviewList";
import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { Divider } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import propTypes from "prop-types";

import StandardCachePageReview from "../ReviewPage/StandardCachePageReview";

const PREFIX = "Review";

const classes = {
  heading: `${PREFIX}-heading`,
  accordion: `${PREFIX}-accordion`,
  buttonMargin: `${PREFIX}-buttonMargin`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.heading}`]: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },

  [`& .${classes.accordion}`]: {
    boxShadow: "unset",
  },

  [`& .${classes.buttonMargin}`]: {
    marginRight: theme.spacing(2),
  },
}));

const Review = ({ labels, setStepImperatively }) => {
  const allLabels = labels.concat(["Advanced Settings"]);

  return (
    <div style={{ width: "100%" }}>
      {allLabels.map((label, index) => (
        <ReviewItem
          key={index}
          {...{
            setStepImperatively,
            label,
            index,
          }}
        />
      ))}
    </div>
  );
};

Review.propTypes = {
  labels: propTypes.arrayOf(propTypes.string),
  setStepImperatively: propTypes.func,
};

const ReviewItem = ({ setStepImperatively, index, label }) => {
  const getReviewList = (label) => {
    if (label === "Web Page Setup") {
      return <StandardCachePageReview />;
    }

    return <ReviewList list={label} />;
  };

  return (
    <Root>
      <Divider />
      <Accordion className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          {" "}
          <Grid container alignItems="center">
            <Tooltip title="Edit" placement="left">
              <IconButton
                className={classes.buttonMargin}
                onClick={() => setStepImperatively(index)}
                onFocus={(event) => event.stopPropagation()}
                size="large"
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Typography component={"span"}>{label}</Typography>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={12}>
            {getReviewList(label)}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Root>
  );
};

ReviewItem.propTypes = {
  label: propTypes.string,
  index: propTypes.number,
  setStepImperatively: propTypes.func,
};

export default Review;
